import * as PIXI from 'pixi.js'
import { createNoise2D } from 'simplex-noise'
import alea from 'alea'
import { drawPlant } from '../pixi/plantRenderer'

const DEFAULT_SNAPSHOT_OPTIONS = {
  width: 160,
  height: 160,
  backgroundColor: 0x000000,
  backgroundAlpha: 0,
}

function normalizePlantForSnapshot(plant, config) {
  if (!plant) return null
  const plantConfig = plant.config || (plant.type ? config?.plants?.[plant.type] : null)
  if (!plantConfig) return null

  return {
    ...plant,
    config: plantConfig,
    progress: plant.progress ?? plantConfig.clicksPerStage * plantConfig.stages,
    plantedAt: plant.plantedAt || Date.now(),
  }
}

export async function generatePlantSnapshot(plant, config, options = {}) {
  if (typeof window === 'undefined') return null

  const normalizedPlant = normalizePlantForSnapshot(plant, config)
  if (!normalizedPlant) return null

  const { width, height, backgroundColor, backgroundAlpha } = {
    ...DEFAULT_SNAPSHOT_OPTIONS,
    ...options,
  }

  const app = new PIXI.Application({
    width,
    height,
    antialias: true,
    backgroundColor,
    backgroundAlpha,
    resolution: window.devicePixelRatio || 1,
  })

  try {
    const stage = app.stage
    stage.removeChildren()

    const plantContainer = new PIXI.Container()
    plantContainer.position.set(width / 2, height - 20)
    stage.addChild(plantContainer)

    const noiseSeed = `${normalizedPlant.id || normalizedPlant.type}-${normalizedPlant.plantedAt}`
    const noise = createNoise2D(alea(noiseSeed))

    drawPlant(
      plantContainer,
      normalizedPlant,
      noise,
      normalizedPlant.config,
      false,
      null,
      normalizedPlant.id || normalizedPlant.type,
    )

    const base64 = app.renderer.plugins.extract.base64(stage)
    return base64
  } catch (error) {
    console.warn('generatePlantSnapshot failed:', error)
    return null
  } finally {
    app.destroy(true, { children: true, texture: true, baseTexture: true })
  }
}
